module.exports = "/img/poster_bf.png?828a7333184b29b301cc8f04c99b5a93";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/poster_bf.png
// module id = up/2
// module chunks = 57